/* mm-schrift.js — Magic Milk
 *
 * Zwei Aufgaben:
 *
 * 1) EINE Überschriften-Schrift statt fünf. Der Shop mischte Titan One,
 *    Josefin Sans, Passion One, Francois One und Poppins in Überschriften,
 *    die alle dieselbe Aufgabe haben. Alle bekommen jetzt die Hausschrift
 *    der grossen Überschriften: Barlow Condensed 800, Versalien.
 *    Die Schriftgrösse bleibt unangetastet — das Layout verschiebt sich nicht.
 *    Produktnamen in Karten bleiben aussen vor, die gehören der App.
 *
 * 2) Text-Effekt auf Fliesstext: Absätze blenden beim Hereinscrollen
 *    Wort für Wort auf (Unschärfe + leichtes Steigen). Überschriften macht
 *    schon mm-bewegung.js — hier wird nichts doppelt zerlegt.
 *
 * Sicherheitsnetz: Nach 6 Sekunden wird jeder Absatz sichtbar gemacht,
 * egal was der Beobachter meldet. Unsichtbarer Text kann nicht entstehen.
 */
(function () {
  var ruhig = false;
  try { ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  var K = 'cubic-bezier(.22,.61,.36,1)';
  var css = [
    /* --- 1. Überschriften-Schrift --- */
    'html body .mmKopfSchrift{',
    'font-family:"Barlow Condensed",sans-serif!important;',
    'font-weight:800!important;text-transform:uppercase!important;',
    'letter-spacing:-.01em!important;line-height:1.08!important}',
    'html body .mmKopfSchrift .mmTeil,html body .mmKopfSchrift .mmTA,',
    'html body .mmKopfSchrift span{font-family:inherit!important;',
    'font-weight:inherit!important;text-transform:inherit!important}',

    /* --- 2. Text-Effekt auf Fliesstext --- */
    /* Gleiche Handschrift wie der Überschriften-Effekt in mm-bewegung.js:
       Unschärfe raus, leicht von unten herein, gestaffelt. */
    'html body .mmAbs .mmW{display:inline-block;will-change:opacity,transform,filter;',
    'opacity:0;filter:blur(10px);transform:translateY(12px);',
    'transition:opacity .5s ' + K + ',filter .5s ' + K + ',transform .5s ' + K + '}',
    'html body .mmAbs.da .mmW{opacity:1;filter:blur(0);transform:none}',
    '@media (prefers-reduced-motion:reduce){',
    'html body .mmAbs .mmW{opacity:1!important;filter:none!important;transform:none!important}}'
  ].join('');

  function stil() {
    if (document.getElementById('mmSchrift-stil')) return;
    var s = document.createElement('style');
    s.id = 'mmSchrift-stil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  /* ------------------------------------------------------------------ */
  /* 1. Überschriften                                                    */
  /* ------------------------------------------------------------------ */

  // Nur Sektions- und Slider-Titel. Bewusst NICHT: Produktnamen in Karten,
  // Kopfzeile, Fusszeile, Navigation, Formulare, Preise.
  var KOPF_ZIELE = [
    '[class*="slider-title-"]',
    '[class*="collections-title-"]',
    '[class*="hero-collection-title"]',
    '[class*="hero-card-title"]',
    '.text-container-s-tr',
    '#MainContent h1',
    '#MainContent h3'
  ].join(',');

  var KOPF_TABU = '.st_card,.card,.product-card,[class*="card_title"],[class*="card-title"],'
    + 'header,footer,nav,form,.mmSek,#mmAufdeck,.mmRInnen,#mmGal';

  function kopfPasst(e) {
    if (e.classList.contains('mmKopfSchrift')) return false;
    if (e.closest(KOPF_TABU)) return false;
    var c = getComputedStyle(e);
    if (parseFloat(c.fontSize) < 22) return false;      // kleine Labels bleiben
    if (/Barlow/.test(c.fontFamily)) return false;      // schon richtig
    var t = (e.textContent || '').replace(/\s+/g, ' ').trim();
    return t.length >= 3 && t.length <= 70;
  }

  function koepfe() {
    var n = 0, liste;
    try { liste = document.querySelectorAll(KOPF_ZIELE); } catch (e) { return 0; }
    [].forEach.call(liste, function (e) {
      if (kopfPasst(e)) { e.classList.add('mmKopfSchrift'); n++; }
    });
    return n;
  }

  /* ------------------------------------------------------------------ */
  /* 2. Fliesstext                                                       */
  /* ------------------------------------------------------------------ */

  // ACHTUNG: nicht '[class*="card"]' verwenden — der <body> trägt die Klasse
  // 'card-hover-effect-scale', damit wäre die ganze Seite gesperrt (Fehler
  // vom 15.08., dadurch wurde kein einziger Absatz animiert).
  // Ebenso nicht '[class*="slider"]': die statische Unterzeile unter einer
  // Überschrift heisst bei Sternify '...slider_card_collection-title-subtitle'
  // und bewegt sich gar nicht. Gesperrt wird nur, was wirklich fährt.
  var ABS_TABU = '.swiper-slide,.swiper-wrapper,.st_card,.card,.product-card,'
    + '[class*="card_desc"],[class*="card_title"],[class*="card__"],'
    + '[class*="marquee"],[class*="ticker"],[class*="announcement"],'
    + 'header,footer,nav,form,button,a,#mmAufdeck,.mmZyl';

  function absatzPasst(p) {
    if (p.dataset.mmAbs) return false;
    if (p.children.length) return false;                 // nur reiner Text
    if (p.closest(ABS_TABU)) return false;
    if (p.classList.contains('mmW') || p.classList.contains('mmTeil')) return false;
    var t = (p.textContent || '').trim();
    var w = t.split(/\s+/).length;
    if (w < 4 || w > 60) return false;
    var c = getComputedStyle(p);
    var gr = parseFloat(c.fontSize);
    if (gr < 13 || gr > 26) return false;                // Fliesstext, keine Überschrift
    if (c.display === 'none' || c.visibility === 'hidden') return false;
    return true;
  }

  function zerlegen(p) {
    var text = p.textContent;
    p.dataset.mmAbs = '1';
    if (ruhig) return;                                   // kein Eingriff
    p.dataset.mmText = text;                             // Original merken
    var woerter = text.split(/(\s+)/);                   // Trenner behalten
    p.textContent = '';
    var i = 0;
    woerter.forEach(function (teil) {
      if (!teil) return;
      if (/^\s+$/.test(teil)) { p.appendChild(document.createTextNode(teil)); return; }
      var s = document.createElement('span');
      s.className = 'mmW';
      s.textContent = teil;
      s.style.transitionDelay = Math.min(i * 26, 620) + 'ms';
      p.appendChild(s);
      i++;
    });
    p.classList.add('mmAbs');
  }

  var beobachter = null;
  function beobachten(p) {
    if (ruhig) return;
    if (!('IntersectionObserver' in window)) { p.classList.add('da'); return; }
    if (!beobachter) {
      beobachter = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('da'); beobachter.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    }
    beobachter.observe(p);
  }

  /* Sicherheitsnetz: nichts darf dauerhaft unsichtbar bleiben. */
  function alleZeigen() {
    [].forEach.call(document.querySelectorAll('.mmAbs:not(.da)'), function (p) {
      p.classList.add('da');
    });
  }

  /* ------------------------------------------------------------------ */

  var MAX = 40, gezaehlt = 0;

  function durchgang() {
    stil();
    koepfe();
    if (gezaehlt >= MAX) return;
    // Auch reine Text-DIVs und Listenpunkte — die Startseite arbeitet fast
    // ohne <p>, ihre Unterzeilen sind DIVs.
    var abs = document.querySelectorAll(
      '#MainContent p,#MainContent li,#MainContent div,main p,main li'
    );
    [].forEach.call(abs, function (p) {
      if (gezaehlt >= MAX) return;
      if (!absatzPasst(p)) return;
      zerlegen(p);
      beobachten(p);
      gezaehlt++;
    });
  }

  function start() {
    durchgang();
    var n = 0;
    var t = setInterval(function () { durchgang(); if (++n > 10) clearInterval(t); }, 800);
    setTimeout(alleZeigen, 6000);
    window.addEventListener('pagehide', alleZeigen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.addEventListener('load', durchgang);
})();
